import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { trim } from 'lodash';

import TextInput from '../TextInput';
import Button from '../Button';
import ValidationError from '../common/ValidationError';
import { IDS } from '../../constants/ids';
import { COMMON } from '../../constants/strings';
import { EDIT_COMMUNITY_VALIDATION_RULES as VALIDATION_RULES } from '../../constants/index';

const EditCommunityForm = ({
  formatMessage,
  onSubmit,
  name,
  description,
  onCancel,
}) => {
  const initialState = {
    name,
    description,
  };
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(values);
  };

  const handleInputChange = (fieldName, value) => {
    const error = validateInput(fieldName, value);
    setValues({
      ...values,
      [fieldName]: value,
    });
    setErrors({
      ...errors,
      [fieldName]: error,
    });
  };

  const validateInput = (fieldName, value) => {
    let error;
    if (
      fieldName === 'name' &&
      (!trim(value) || value.length < VALIDATION_RULES.NAME_MIN_LENGTH)
    ) {
      error = formatMessage(
        { id: 'chat.errors.minLength' },
        { length: VALIDATION_RULES.NAME_MIN_LENGTH },
      );
    }
    if (
      fieldName === 'name' &&
      value.length > VALIDATION_RULES.NAME_MAX_LENGTH
    ) {
      error = formatMessage(
        { id: 'chat.errors.tooLong' },
        { length: VALIDATION_RULES.NAME_MAX_LENGTH },
      );
    }
    if (
      fieldName === 'description' &&
      value.length > VALIDATION_RULES.DESCRIPTION_MAX_LENGTH
    ) {
      error = formatMessage(
        { id: 'chat.errors.tooLong' },
        { length: VALIDATION_RULES.DESCRIPTION_MAX_LENGTH },
      );
    }
    return error;
  };

  return (
    <form onSubmit={handleSubmit}>
      <Fragment>
        <TextInput
          type="text"
          label={formatMessage({ id: 'community.communityName' })}
          placeholder={formatMessage({ id: 'community.communityName' })}
          limit={VALIDATION_RULES.NAME_MAX_LENGTH + 1}
          name="name"
          value={values.name}
          onChange={val => handleInputChange('name', val)}
        />
        <ValidationError content={errors.name} className="mb3" />
      </Fragment>
      <Fragment>
        <TextInput
          textarea
          rows="4"
          type="text"
          label={formatMessage({ id: 'common.description' })}
          placeholder={formatMessage({ id: 'common.description' })}
          limit={VALIDATION_RULES.DESCRIPTION_MAX_LENGTH + 1}
          name="description"
          value={values.description}
          onChange={val => handleInputChange('description', val)}
        />
        <ValidationError content={errors.description} />
      </Fragment>
      <div className="mt3">
        <Button
          id={IDS.COMMUNITY.MENU_EDIT}
          className="mr3"
          raised
          color="primary"
          type="submit"
          disabled={Boolean(errors.description || errors.name)}
        >
          {formatMessage(COMMON.save)}
        </Button>
        <Button
          id={IDS.COMMUNITY.MENU_CANCEL}
          raised
          color="accent"
          type="button"
          onClick={onCancel}
        >
          {formatMessage(COMMON.cancel)}
        </Button>
      </div>
    </form>
  );
};

EditCommunityForm.propTypes = {
  formatMessage: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  name: PropTypes.string,
  description: PropTypes.string,
};

export default EditCommunityForm;



// WEBPACK FOOTER //
// ./src/components/Community/EditCommunityForm.jsx